import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../theme/ThemeProvider";

const ThemeToggle = ({ inverted = false }) => {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      onClick={toggle}
      aria-label="Toggle theme"
      className={`h-9 w-9 rounded-full border transition-colors flex items-center justify-center ${
        inverted
          ? "border-white/20 text-white hover:bg-white/10"
          : "border-slate-200 text-[#0B1B3B] hover:border-[#1E56E3] hover:text-[#1E56E3] dark:border-white/20 dark:text-white dark:hover:bg-white/10"
      }`}
    >
      {isDark ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
};

export default ThemeToggle;
